/* eslint-disable react-hooks/exhaustive-deps */

import "./TopicStartegyBuilder.scss";

import { ArrowForward, RemoveCircleOutlined } from "@mui/icons-material";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardHeader,
  Checkbox,
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import { FixedSizeList, ListChildComponentProps } from "react-window";
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  convertJsonToCsv,
  exportJsonToCsv,
  exportJsonToCsvForFifthStep,
} from "./JsonToCsv";

import AddIcon from "@mui/icons-material/Add"; // Filled Add (+) icon
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { Close } from "@mui/icons-material";
import CustomToast from "../../utils/cutomToast/CustomToast";
import DoneIcon from "@mui/icons-material/Done";
import DownloadIcon from "@mui/icons-material/Download";
import GetKeywordsTable from "./GetKeywordsTable";
import IntentClusters from "./IntentClusters";
import Loader from "../../utils/loader/Loader";
import Stepper from "./Stepper";
import axios from "axios";
import { urlConstants } from "../../components/constants/globalConstants";
import { useLocation } from "react-router-dom";

//import Stepper from "./Stepper";

interface firstStep {
  keywords: [];
}

const LISTBOX_HEIGHT = 250;
const ITEM_HEIGHT = 40;

const VirtualizedListbox = React.forwardRef<HTMLDivElement, any>(
  function ListboxComponent(props, ref) {
    const { children, ...other } = props;
    const items = React.Children.toArray(children);

    return (
      <div ref={ref} {...other}>
        <FixedSizeList
          height={LISTBOX_HEIGHT}
          width="100%"
          itemSize={ITEM_HEIGHT}
          itemCount={items.length}
        >
          {({ index, style }: ListChildComponentProps) => (
            <div
              style={{
                ...style,
                display: "flex",
                alignItems: "center",
                overflow: "hidden",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
              }}
            >
              {items[index]}
            </div>
          )}
        </FixedSizeList>
      </div>
    );
  }
);

const TopicStartegyBuilder = () => {
  const loca_tion = useLocation();
  // Create a URLSearchParams object
  const queryParams = new URLSearchParams(loca_tion.search);
  const jobId = queryParams.get("JobId");
  const actionType = queryParams.get("Action");
  const [action, setAction] = useState(actionType);

  const [tabIndex, setTabIndex] = useState(0);
  const countryCodeRef = useRef(true);
  const [loading, setLoading] = useState(false);

  // firsttab
  const [url, setUrl] = useState("");
  const [csvFile, setCsvFile] = useState<any>(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [firstStepData, setFirstStepData] = useState<firstStep>({
    keywords: [],
  });
  const [isSeed, setIsSeed] = useState(false);
  const [seed, setSeed] = useState("");

  //secondTab
  const [selectedOptions, setSelectedOptions] = useState<string[]>(["all"]);
  const [secondTabData, setSecondTabData] = useState<any>({
    aggregated_keywords: [],
  });

  //const [secondTabCsv, setSecondTabCsv] = useState<string>("");
  const options = [
    { key: "all", value: "All" },
    { key: "semrush", value: "Semrush" },
    { key: "google_suggest", value: "Google Suggest" },
    { key: "questions", value: "Questions" },
    { key: "related", value: "Related" },
  ];
  const [database, setDatabase] = useState("us");
  const [databases, setDatabases] = useState([]);

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;

    if (name === "all") {
      setSelectedOptions(checked ? options.map((opt) => opt.key) : []);
    } else {
      let updatedOptions = checked
        ? [...selectedOptions, name]
        : selectedOptions.filter((item) => item !== name);

      if (updatedOptions.length === options.length - 1) {
        updatedOptions = ["all", ...updatedOptions];
      } else {
        updatedOptions = updatedOptions.filter((item) => item !== "all");
      }

      setSelectedOptions(updatedOptions);
    }
  };

  //thirdTab
  const [brand, setBrand] = useState("");
  const [location, setLocation] = useState("");
  const [thirdTabData, setThirdTabData] = useState<any>({
    replaced_keywords: [],
  });

  //fourthTab
  const [algorithm, setAlgorithm] = useState("");
  const [overlap, setOverlap] = useState("");
  const [countryCode, setCountryCode] = useState("us");
  const [locationFourthTab, setLocationFourthTab] = useState("");
  const [locations, setLocations] = useState<any[]>([]);
  const [forNextStepCsv, setForNextStepCsv] = useState<string>("");
  const [stepper, setStepper] = useState<any[]>([]);
  const [clusters, setClusters] = useState<any[]>([]);
  const [groupClusters, setGroupClusters] = useState<any[]>([]);
  const [firstTimeRunFourthTab, setFirstTimeRunFourthTab] = useState(false);
  const [firstTimeRunFifthTab, setFirstTimeRunFifthTab] = useState(false);
  const [inputFilePathForFifthStep, setInputFilePathForFifthStep] =
    useState("");
  const jobRunHandle = useRef(true);

  //fifthTab
  const [tightness, setTightness] = useState("");
  const [intentClusters, setIntentCluster] = useState<any[]>([]);
  const [fifthStepper, setFifthStepper] = useState<any[]>([]);
  const [groupIntentClusters, setGroupIntentClusters] = useState<any[]>([]);
  const [forNextFifthStepCsv, setForNextFifthStepCsv] = useState<string>("");

  const totalTabs = 5;
  const [completedSteps, setCompletedSteps] = useState<number[]>([0]);

  const handleNext = () => {
    if (tabIndex === 0 && firstStepData.keywords.length > 0) {
      handleSubmitForFirstTab(null, firstStepData.keywords);
    }
    if (tabIndex === 3 && inputFilePathForFifthStep === "") {
      CustomToast("please check file in stepper", "error");
      return;
    }
    if (tabIndex < totalTabs - 1) {
      setCompletedSteps([...completedSteps, tabIndex + 1]);
      setTabIndex(tabIndex + 1);
      jobRunHandle.current = true;
    }
  };

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    if (completedSteps.includes(newValue)) {
      setTabIndex(newValue);
      jobRunHandle.current = true;
    }
  };

  // first tab Handle page change
  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  // first tab Handle rows per page change
  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleCsvUpload = (event: any) => {
    setCsvFile(event.target.files[0]);
  };

  const handleIconClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleConfirmSeed = () => {
    const tableDataKeywords = firstStepData.keywords;
    const updatedSeeds = [...tableDataKeywords, seed];
    setFirstStepData((prev: any) => ({
      ...prev,
      keywords: updatedSeeds,
    }));
    //handleSubmitForFirstTab(null, updatedSeeds);
    setIsSeed(false);
  };

  const handleErrorForJsonFetch = async (error: any) => {
    if (error.response) {
      if (error.response.status === 404) {
        setAction("new");
        CustomToast(
            error?.response?.data?.detail[0]?.msg ||
            error?.response?.data?.detail || "Previously you didn't process this step.",
          "error"
        );
      } else if (error.response.status === 500) {
        CustomToast( error?.response?.data?.detail[0]?.msg ||
            error?.response?.data?.detail || "Server Error.", "error");
      } else {
        CustomToast(error?.response?.data?.detail[0]?.msg ||
            error?.response?.data?.detail || "Something went wrong.", "error");
      }
    } else {
      CustomToast(error?.response?.data?.detail[0]?.msg ||
            error?.response?.data?.detail || "Something went wrong.", "error");
    }
  };

  const handleError = async (error: any) => {
    if (error.response) {
      if (error.response.status === 404) {
        CustomToast(
          error?.response?.data?.detail[0]?.msg ||
            error?.response?.data?.detail || "No Data Found.",
          "error"
        );
      } else if (error.response.status === 500) {
        CustomToast(
          error?.response?.data?.detail[0]?.msg ||
            error?.response?.data?.detail || "Server Error.",
          "error"
        );
      } else {
        CustomToast( error?.response?.data?.detail[0]?.msg ||
            error?.response?.data?.detail || "Something went wrong.", "error");
      }
    } else {
      CustomToast(error?.response?.data?.detail[0]?.msg ||
            error?.response?.data?.detail || "Something went wrong.", "error");
    }
  };

  const fetchJsonResponse = async (url: string) => {
    const res = await axios.get(url, {
      maxBodyLength: Infinity,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    return res.data;
  };

  const GetDatabases = async () => {
    try {
      const res = await fetchJsonResponse(
        `${urlConstants.PROMPT_URL}/aggregated-keywords-from-sources/options`
      );
      setDatabases(res?.databases);
    } catch (error: any) {
      setDatabases([]);
      await handleError(error);
      return;
    }
  };

  const ConvertToJSONToCSV = (json: any, filename: string, tab = 0) => {
    var csv = null;
    if (tab === 4) {
      csv = exportJsonToCsv(json);
    } else if (tab === 5) {
      csv = exportJsonToCsvForFifthStep(json);
    } else {
      csv = convertJsonToCsv(json);
    }

    const blob = csv && new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = blob ? URL.createObjectURL(blob) : "";

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${filename}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleRemoveSeedKeyword = (index: number) => {
    // Extract keywords from firstStepData
    const tableDataKeywords = firstStepData.keywords;
    const updatedTableDataKeywords = tableDataKeywords.filter(
      (_, i) => i !== index
    );
    setFirstStepData((prev: any) => ({
      ...prev,
      keywords: updatedTableDataKeywords,
    }));
    //handleSubmitForFirstTab(null, updatedTableDataKeywords);
  };

  const handleSubmitForFirstTab = async (
    csv: any,
    finalConfirmSeeds: any = []
  ) => {
    const formData = new FormData();
    if (csv) {
      formData.append("csv_file", csv);
    }
    formData.append("model_id", "gpt-4o");
    formData.append("additional_keywords", finalConfirmSeeds.join(","));
    try {
      setLoading(true);
      let response: any;
      if (action === "new") {
        try {
          response = await axios.post(
            `${urlConstants.PROMPT_URL}/generate-seed-keywords?jobid=${jobId}`,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" },
            }
          );
        } catch (error: any) {
          await handleError(error);
          return;
        }
      } else {
        try {
          response = await axios.get(
            `${urlConstants.PROMPT_URL}/generate-seed-keywords?jobid=${jobId}`
          );
        } catch (error: any) {
          await handleErrorForJsonFetch(error);
          return;
        }
      }
      const res: any = response.data;
      if (res.status === "success") {
        try {
          if(res?.output_data?.download_url){   
            const finalRes: any = await fetchJsonResponse(
              res?.output_data?.download_url
            );
            setFirstStepData(finalRes);
          }else{
             CustomToast(res?.output_data.errors[0] || "output file path not found", "error")
          }
        } catch (error: any) {
          if (action === "new") {
            await handleError(error);
          } else {
            await handleErrorForJsonFetch(error);
          }
          return;
        }
      } else {
        CustomToast(res?.output_data?.errors[0] || res.detail || res.detail[0].msg || res.message || "failed to generate keywords.", "error");
        setFirstStepData({
          keywords: [],
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const getLocations = async (country: string) => {
    if (!country) return;
    setLoading(true);
    try {
      const res = await fetchJsonResponse(
        `${urlConstants.PROMPT_URL}/create-intent-clusters/options?country=${country}`
      );
      const locationsData = res.locations || [];
      setLocations(locationsData);

      // Dynamic timeout based on data length
      const timeoutDuration = Math.min(
        Math.max(locationsData.length * 10, 2000),
        20000
      );
      setTimeout(() => {
        setLoading(false);
      }, timeoutDuration);
    } catch (error: any) {
      await handleError(error);
      return;
    } finally {
      setLoading(false);
    }
  };

  // Memoize locations for performance
  const memoizedOptions = useMemo(() => locations, [locations]);

  useEffect(() => {
    if (countryCode && countryCodeRef.current) {
      getLocations(countryCode);
      setSecondTabData({ aggregated_keywords: [] });
      setThirdTabData({
        replaced_keywords: [],
      });
      countryCodeRef.current = false;
    }
  }, [countryCode, countryCodeRef.current]);

  useEffect(() => {
    if (tabIndex === 0) {
      setClusters([]);
      setIntentCluster([]);
      setGroupClusters([]);
      setGroupIntentClusters([]);
      setStepper([]);
      setFifthStepper([]);
      setFirstTimeRunFourthTab(false);
      setFirstTimeRunFifthTab(false);
      GetDatabases();
    }
  }, [tabIndex]);

  const handleSubmitForSecondTab = async () => {
    try {
      setLoading(true);
      let response: any;
      if (action === "new") {
        try {
          response = await axios.post(
            `${urlConstants.PROMPT_URL}/aggregated-keywords-from-sources?jobid=${jobId}`,
            { apis: selectedOptions, database: database },
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "accept: application/json",
              },
            }
          );
        } catch (error: any) {
          await handleError(error);
          return;
        }
      } else {
        try {
          response = await axios.get(
            `${urlConstants.PROMPT_URL}/aggregated-keywords-from-sources?jobid=${jobId}`
          );
        } catch (error: any) {
          await handleErrorForJsonFetch(error);
          return;
        }
      }

      const res: any = response.data;
      if (res.status === "success") {
        try {
          const finalRes: any = await fetchJsonResponse(
            res?.output_data?.download_url
          );
          if (action !== "new") {
            setSelectedOptions(res?.metadata?.apis);
          }
          setSecondTabData(finalRes);
        } catch (error: any) {
          if (action === "new") {
            await handleError(error);
          } else {
            await handleErrorForJsonFetch(error);
          }
          return;
        }
      } else {
        CustomToast(res?.output_data?.errors[0] || res.detail || res.detail[0].msg || res.message, "error");
        setSecondTabData({ aggregated_keywords: [] });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitForThirdTab = async () => {
    const inputPayload = {
      brand_name: brand,
      location: location,
    };

    try {
      setLoading(true);
      let response: any;
      if (action === "new") {
        try {
          response = await axios.post(
            `${urlConstants.PROMPT_URL}/replace-keywords?jobid=${jobId}`,
            inputPayload,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "accept: application/json",
              },
            }
          );
        } catch (error: any) {
          await handleError(error);
          return;
        }
      } else {
        try {
          response = await axios.get(
            `${urlConstants.PROMPT_URL}/replace-keywords?jobid=${jobId}`
          );
        } catch (error: any) {
          await handleErrorForJsonFetch(error);
          return;
        }
      }
      const res: any = response.data;
      if (res.status === "success") {
        try {
          const finalRes: any = await fetchJsonResponse(
            res?.output_data?.download_url
          );
          if (action !== "new") {
            setBrand(res?.metadata?.brand_name);
            setLocation(res?.metadata?.location);
          }
          setThirdTabData(finalRes);
        } catch (error: any) {
          if (action === "new") {
            await handleError(error);
          } else {
            await handleErrorForJsonFetch(error);
          }
          return;
        }
      } else {
        setThirdTabData({
          replaced_keywords: [],
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitForFourthTab = async (control: string) => {
    try {
      setLoading(true);
      const requestBody = {
        country: countryCode,
        location: locationFourthTab,
        algorithm: algorithm,
        url_overlap: parseInt(overlap, 10),
      };
      let response: any;
      let finalRes: any;
      let filePathURL = "";
      if (action === "new" || control === "rerun" || control === "direct") {
        try {
          response = await axios.post(
            `${urlConstants.PROMPT_URL}/create-intent-clusters?jobid=${jobId}`,
            requestBody,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "accept: application/json",
              },
            }
          );

          finalRes = response.data;
          filePathURL = finalRes?.metadata?.output_file_path;
        } catch (error: any) {
          await handleError(error);
          return;
        }
      } else {
        try {
          response = await axios.get(
            `${urlConstants.PROMPT_URL}/create-intent-clusters?jobid=${jobId}`
          );
          finalRes = Object.values(response.data.data);
        } catch (error: any) {
          await handleErrorForJsonFetch(error);
          return;
        }
      }
      if (
        finalRes.status === "success" ||
        finalRes.status === "pending" ||
        finalRes.length > 0
      ) {
        try {
          if (action === "new" || control === "rerun" || control === "direct") {
            do {
              const response = await axios.get(
                `${urlConstants.PROMPT_URL}/create-intent-clusters?jobid=${jobId}`
              );

              finalRes = Object.values(response.data.data);

              if (
                [...finalRes].some(
                  (item: any) =>
                    item.status === "processing" || item.status === "pending"
                )
              ) {
                await new Promise((resolve) => setTimeout(resolve, 10000));
              }
            } while (
              [...finalRes].some(
                (obj: any) =>
                  obj.status === "processing" || obj.status === "pending"
              )
            );
          }
          const newGroupClusters: any[] = [];
          const newStepper: string[] = [];
          for (const result of finalRes) {
            const finalClusters = await fetchJsonResponse(
              result?.output_data?.download_url
            );
            newStepper.push(result?.output_data?.output_path);
            newGroupClusters.push({
              [result?.output_data?.output_path]: finalClusters.clusters,
              output_file_path: result?.output_data?.output_path,
              algorithm_step: result?.metadata?.algorithm,
              overlap_step: result?.metadata?.url_overlap,
              location_step: result?.metadata?.location,
              country_step: result?.metadata?.country,
            });
          }
          setGroupClusters([...newGroupClusters]);
          setStepper([...newStepper]);
          setInputFilePathForFifthStep(finalRes[0]?.output_data?.output_path);
          if (filePathURL) {
            setForNextStepCsv(filePathURL);
          } else {
            setForNextStepCsv(finalRes[0]?.output_data?.output_path);
          }
          setFirstTimeRunFourthTab(true);
        } catch (error: any) {
          if (action === "new") {
            await handleError(error);
          } else {
            await handleErrorForJsonFetch(error);
          }
          return;
        }
      } else {
        CustomToast(
          finalRes?.output_data?.errors[0] || finalRes.msg || finalRes.detail || finalRes?.detail[0]?.msg || "No data found.",
          "error"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitForFifthTab = async (control: string) => {
    try {
      setLoading(true);
      const inputPayload = {
        threshold_setting: tightness,
        input_file_path: inputFilePathForFifthStep,
      };
      let response: any;
      let finalRes: any;
      let filePathURL = "";
      if (action === "new" || control === "rerun" || control === "direct") {
        try {
          response = await axios.post(
            `${urlConstants.PROMPT_URL}/create-topic-clusters?jobid=${jobId}`,
            inputPayload,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "accept: application/json",
              },
            }
          );
          finalRes = response.data;
          filePathURL = finalRes?.metadata?.output_file_path;
        } catch (error: any) {
          await handleError(error);
          return;
        }
      } else {
        try {
          response = await axios.get(
            `${urlConstants.PROMPT_URL}/create-topic-clusters?jobid=${jobId}`
          );
          finalRes = Object.values(response.data.data);
          if (
            [...finalRes].some(
              (item: any) =>
                item.status === "processing" || item.status === "pending"
            )
          ) {
            await new Promise((resolve) => setTimeout(resolve, 5000));
          }
        } catch (error: any) {
          await handleErrorForJsonFetch(error);
          return;
        }
      }

      if (
        finalRes.status === "success" ||
        finalRes.status === "pending" ||
        finalRes.length > 0
      ) {
        try {
          if (action === "new" || control === "rerun" || control === "direct") {
            do {
              const response = await axios.get(
                `${urlConstants.PROMPT_URL}/create-topic-clusters?jobid=${jobId}`
              );

              finalRes = Object.values(response.data.data);
              if (
                [...finalRes].some(
                  (item: any) =>
                    item.status === "processing" || item.status === "pending"
                )
              ) {
                await new Promise((resolve) => setTimeout(resolve, 10000));
              }
            } while (
              [...finalRes].some(
                (item: any) =>
                  item.status === "processing" || item.status === "pending"
              )
            );
          }
          const newGroupClusters: any[] = [];
          const newStepper: string[] = [];
          for (const result of finalRes) {
            const finalClusters = await fetchJsonResponse(
              result?.output_data?.download_url
            );
            newStepper.push(result?.output_data?.output_path);
            newGroupClusters.push({
              [result?.output_data?.output_path]: finalClusters,
              output_file_path: result?.output_data?.output_path,
              threshold_setting_step: result?.metadata?.threshold_setting,
            });
          }
          setGroupIntentClusters([...newGroupClusters]);
          setFifthStepper([...newStepper]);
          if (filePathURL) {
            setForNextFifthStepCsv(filePathURL);
          } else {
            setForNextFifthStepCsv(finalRes[0]?.output_data?.output_path);
          }
          setFirstTimeRunFifthTab(true);
        } catch (error: any) {
          if (action === "new") {
            await handleError(error);
          } else {
            await handleErrorForJsonFetch(error);
          }
          return;
        }
      } else {
        CustomToast(
          finalRes?.output_data?.errors[0] || finalRes.msg || finalRes.detail || finalRes.detail[0].msg || "No data found.",
          "error"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (jobRunHandle.current) {
      if (action === "update") {
        if (tabIndex === 0) {
          handleSubmitForFirstTab(null, []);
        }
        if (tabIndex === 1) {
          handleSubmitForSecondTab();
        }
        if (tabIndex === 2) {
          handleSubmitForThirdTab();
        }
        if (tabIndex === 3) {
          handleSubmitForFourthTab("tab");
        }

        if (tabIndex === 4) {
          handleSubmitForFifthTab("tab");
        }
      }
      jobRunHandle.current = false;
    }
  }, [action, tabIndex, jobRunHandle]);

  useEffect(() => {
    if (forNextStepCsv) {
      const currentCluster = groupClusters.find(
        (cluster: any) => cluster.output_file_path === forNextStepCsv
      );
      const clustersArray = currentCluster
        ? currentCluster[forNextStepCsv]
        : [];
      setInputFilePathForFifthStep(currentCluster?.output_file_path);
      if (action !== "new") {
        setAlgorithm(currentCluster?.algorithm_step);
        setOverlap(currentCluster?.overlap_step);
        setLocationFourthTab(currentCluster?.location_step);
        setCountryCode(currentCluster?.country_step);
      }
      setClusters(clustersArray);
    }
  }, [forNextStepCsv]);

  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    const hours = `${date.getHours()}`.padStart(2, "0");
    const minutes = `${date.getMinutes()}`.padStart(2, "0");
    const seconds = `${date.getSeconds()}`.padStart(2, "0");

    return `${year}-${month}-${day}-${hours}${minutes}${seconds}`;
  };

  useEffect(() => {
    if (forNextFifthStepCsv) {
      const currentCluster = groupIntentClusters.find(
        (cluster: any) => cluster.output_file_path === forNextFifthStepCsv
      );
      const clustersArray = currentCluster
        ? currentCluster[forNextFifthStepCsv]
        : [];
      if (action !== "new") {
        setTightness(currentCluster?.threshold_setting_step);
      }
      setIntentCluster(clustersArray);
    }
  }, [forNextFifthStepCsv]);

  const isSubmitDisabled =
    !algorithm || !overlap || !countryCode || !locationFourthTab;

  return (
    <Box className="startegy-main-container">
      <Loader spinning={loading}>
        <Box className="startegy-inner-container">
          <Box className="title-container">
            <Box className="title">
              <Typography
                variant="h4"
                sx={{
                  color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
                  textAlign: "center",
                  fontFeatureSettings: "'liga' off, 'clig' off",
                }}
              >
                Topic Strategy Builder
              </Typography>
            </Box>
          </Box>

          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            className="tabs-container"
            variant="scrollable"
            scrollButtons="auto"
          >
            {[
              { key: "seed-keywords", value: 0, label: "Seed Keywords" },
              { key: "get-keywords", value: 1, label: "Get Keywords" },
              { key: "clean-filter", value: 2, label: "Clean & Filter" },
              { key: "intent-clusters", value: 3, label: "Intent Clusters" },
              { key: "topic-clusters", value: 4, label: "Topic Clusters" },
            ].map((tab) => (
              <Tab
                key={tab.key}
                value={tab.value}
                className="tab"
                disabled={!completedSteps.includes(tab.value)} // Disable uncompleted steps
                sx={{
                  opacity: tabIndex === tab.value ? 1 : 0.5,
                  transition: "opacity 0.3s ease-in-out",
                }}
                label={
                  <Box className="tab-label">
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        alignItems: "flex-start",
                        rowGap: "0.25rem",
                        textAlign: "left",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <Typography className="tab-label-text">
                        STEP {tab.value + 1}
                      </Typography>
                      <Typography className="tab-label-text">
                        {tab.label}
                      </Typography>
                    </Box>
                    <ArrowForward />
                  </Box>
                }
              />
            ))}
          </Tabs>

          {tabIndex === 0 && (
            <>
              <Box className="first-tab">
                <Box className="upload-container">
                  <TextField
                    id="enter-url"
                    label="Enter URL"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    variant="filled"
                    size="medium"
                    sx={{ width: 378 }}
                  />

                  <Typography variant="body1">OR</Typography>

                  <TextField
                    id="upload-csv"
                    label="Upload CSV"
                    value={csvFile ? csvFile.name : ""}
                    variant="filled"
                    size="medium"
                    sx={{ width: 378 }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <AttachFileIcon
                            style={{ cursor: "pointer" }}
                            onClick={handleIconClick}
                          />
                        </InputAdornment>
                      ),
                    }}
                  />
                  <input
                    type="file"
                    accept=".csv"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleCsvUpload}
                  />
                </Box>

                {/* Submit Button */}
                <Button
                  color="primary"
                  variant="outlined"
                  size="large"
                  onClick={() => handleSubmitForFirstTab(csvFile || url)}
                  disabled={!url && !csvFile}
                >
                  Submit
                </Button>
              </Box>
              <Divider
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  alignSelf: "stretch",
                }}
              />
              <Card className="card-container">
                <CardHeader
                  className="card-header"
                  title={
                    <Box className="card-header-inner">
                      <Typography
                        variant="h5"
                        sx={{
                          alignSelf: "stretch",
                          color: "rgba(0, 0, 0, 0.87) !important",
                          fontFeatureSettings: "'liga' off, 'clig' off",
                        }}
                      >
                        Seed Keywords
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "rgba(0, 0, 0, 0.87)",
                          opacity: 0.6,
                          fontFeatureSettings: "'liga' off, 'clig' off",
                        }}
                      >
                        {firstStepData.keywords.length} total keywords
                      </Typography>
                    </Box>
                  }
                />
                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow></TableRow>
                      </TableHead>
                      <TableBody>
                        {/* Processed Keywords */}
                        {firstStepData.keywords.length > 0 &&
                          firstStepData.keywords
                            .map((word: string) => word.trim()) // Trim whitespace
                            .filter(Boolean) // Remove empty values
                            .slice(
                              page * rowsPerPage,
                              page * rowsPerPage + rowsPerPage
                            ) // Pagination
                            .map((row, index) => (
                              <TableRow
                                key={index}
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <TableCell
                                  sx={{
                                    padding: "10px !important",
                                    borderBottom:
                                      "1px solid rgba(0, 0, 0, 0.06) !important",
                                    width: "90%",
                                  }}
                                >
                                  {row}
                                </TableCell>
                                <TableCell
                                  sx={{
                                    padding: "10px !important",
                                    borderBottom:
                                      "1px solid rgba(0, 0, 0, 0.06) !important",
                                    width: "10%",
                                  }}
                                >
                                  <IconButton
                                    onClick={() =>
                                      handleRemoveSeedKeyword(index)
                                    }
                                    className="icon-button"
                                  >
                                    <RemoveCircleOutlined
                                      style={{
                                        color: "#000000",
                                        opacity: "0.12",
                                      }}
                                    />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            ))}

                        {/* Add Seed Input Row */}
                        {isSeed && (
                          <TableRow>
                            <TableCell>
                              <TextField
                                value={seed}
                                onChange={(e) => setSeed(e.target.value)}
                                size="small"
                                variant="outlined"
                                placeholder="Enter Seed Keyword"
                              />
                            </TableCell>
                            <TableCell>
                              <IconButton
                                color="success"
                                onClick={handleConfirmSeed}
                              >
                                <DoneIcon />
                              </IconButton>
                              <IconButton
                                color="error"
                                onClick={() => {
                                  setSeed("");
                                  setIsSeed(false);
                                }}
                              >
                                <Close />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>

                  {/* Pagination */}
                  <TablePagination
                    rowsPerPageOptions={[100, 200, 300, 400, 500, 1000]}
                    component="div"
                    count={firstStepData.keywords.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                  <Box className="table-footer">
                    <Button
                      size="medium"
                      color="primary"
                      variant="text"
                      className="addicon"
                      startIcon={<AddIcon />}
                      onClick={() => {
                        setSeed("");
                        setIsSeed(true);
                      }}
                    >
                      {" "}
                      Add Seed
                    </Button>
                  </Box>
                </Paper>
              </Card>
              <Box className="footer-icons">
                <Button
                  size="large"
                  color="primary"
                  variant="outlined"
                  className="addicon"
                  startIcon={<DownloadIcon />}
                  disabled={firstStepData.keywords.length === 0}
                  onClick={() =>
                    ConvertToJSONToCSV(
                      firstStepData,
                      `keywords-${formatDate(new Date())}`,
                      1
                    )
                  }
                >
                  {" "}
                  CSV
                </Button>
                <Button
                  size="large"
                  color="primary"
                  variant="contained"
                  className="addicon"
                  onClick={handleNext}
                  disabled={firstStepData.keywords.length === 0}
                  endIcon={<ArrowForward />}
                >
                  {" "}
                  Next
                </Button>
              </Box>
            </>
          )}
          {tabIndex === 1 && (
            <>
              <Box className="secondTab">
                <FormGroup className="controls">
                  {options.map((option) => (
                    <FormControlLabel
                      key={option.key}
                      control={
                        <Checkbox
                          checked={selectedOptions.includes(option.key)}
                          onChange={handleCheckboxChange}
                          name={option.key}
                        />
                      }
                      label={option.value}
                    />
                  ))}
                </FormGroup>
                <FormControl sx={{ width: 90 }}>
                  <InputLabel id="database-select-label">Database</InputLabel>
                  <Select
                    labelId="database-select-label"
                    id="database-select"
                    value={database}
                    label="Database"
                    onChange={(e) => setDatabase(e.target.value)}
                  >
                    {databases.length > 0 &&
                      databases.map((val: any) => (
                        <MenuItem value={val.toLowerCase()}>
                          {val.toUpperCase()}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                <Button
                  variant="outlined"
                  size="large"
                  color="primary"
                  onClick={handleSubmitForSecondTab}
                >
                  Submit
                </Button>
              </Box>
              <Divider
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  alignSelf: "stretch",
                }}
              />
              <GetKeywordsTable
                apiResponse={secondTabData?.aggregated_keywords}
                tab={1}
              />
              <Box className="footer-icons">
                <Button
                  size="large"
                  color="primary"
                  variant="outlined"
                  className="addicon"
                  startIcon={<DownloadIcon />}
                  disabled={secondTabData?.aggregated_keywords.length === 0}
                  onClick={() =>
                    ConvertToJSONToCSV(
                      secondTabData,
                      `aggregated_keywords-${formatDate(new Date())}`,
                      2
                    )
                  }
                >
                  CSV
                </Button>
                <Button
                  size="large"
                  color="primary"
                  variant="contained"
                  className="addicon"
                  onClick={handleNext}
                  disabled={secondTabData.length === 0}
                  endIcon={<ArrowForward />}
                >
                  Next
                </Button>
              </Box>
            </>
          )}
          {tabIndex === 2 && (
            <>
              <Box className="thirdTab">
                <Box className="controls">
                  <TextField
                    id="enter-brand"
                    label="Brand"
                    value={brand}
                    onChange={(e) => setBrand(e.target.value)}
                    variant="filled"
                    size="medium"
                    sx={{ width: 378 }}
                  />
                  <TextField
                    id="enter-location"
                    label="Location"
                    value={location}
                    onChange={(e) => setLocation(e.target.value)}
                    variant="filled"
                    size="medium"
                    sx={{ width: 378 }}
                  />
                </Box>
                <Button
                  variant="outlined"
                  size="large"
                  color="primary"
                  disabled={!brand || !location}
                  onClick={handleSubmitForThirdTab}
                >
                  Submit
                </Button>
              </Box>
              <Divider
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  alignSelf: "stretch",
                }}
              />
              <GetKeywordsTable
                apiResponse={thirdTabData?.replaced_keywords}
                tab={2}
                count={secondTabData?.aggregated_keywords.length}
              />
              <Box className="footer-icons">
                <Button
                  size="large"
                  color="primary"
                  variant="outlined"
                  className="addicon"
                  startIcon={<DownloadIcon />}
                  disabled={thirdTabData.length === 0}
                  onClick={() =>
                    ConvertToJSONToCSV(
                      thirdTabData,
                      `replaced_keywords-${formatDate(new Date())}`,
                      3
                    )
                  }
                >
                  CSV
                </Button>
                <Button
                  size="large"
                  color="primary"
                  variant="contained"
                  className="addicon"
                  onClick={handleNext}
                  disabled={thirdTabData.length === 0}
                  endIcon={<ArrowForward />}
                >
                  Next
                </Button>
              </Box>
            </>
          )}
          {tabIndex === 3 && (
            <>
              <Box className="fourthTab">
                <Box className="controls">
                  <FormControl sx={{ width: 180 }}>
                    <InputLabel id="algorithm-select-label">
                      Algorithm
                    </InputLabel>
                    <Select
                      labelId="algorithm-select-label"
                      id="algorithm-select"
                      value={algorithm}
                      label="Age"
                      disabled={firstTimeRunFourthTab}
                      onChange={(e) => setAlgorithm(e.target.value)}
                    >
                      <MenuItem value="Centroid">Centroid</MenuItem>
                      <MenuItem value="Agglomerative">Agglomerative</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl sx={{ width: 180 }}>
                    <InputLabel id="overlap-select-label">Overlap</InputLabel>
                    <Select
                      labelId="overlap-select-label"
                      id="overlap-select"
                      value={overlap}
                      label="overlap"
                      disabled={firstTimeRunFourthTab}
                      onChange={(e) => setOverlap(e.target.value)}
                    >
                      {[...Array(10)].map((_, index) => (
                        <MenuItem key={index + 1} value={index + 1}>
                          {index + 1}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormControl sx={{ width: 180 }}>
                    <Autocomplete
                      options={databases}
                      getOptionLabel={(option: any) => option.toUpperCase()}
                      value={countryCode}
                      disabled={firstTimeRunFourthTab}
                      onChange={(event: any, newValue: any) => {
                        countryCodeRef.current = true;
                        setCountryCode(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField {...params} label="Country Code" />
                      )}
                    />
                  </FormControl>
                  <FormControl sx={{ width: 250 }}>
                    <Autocomplete
                      options={memoizedOptions || []}
                      disableListWrap
                      ListboxComponent={VirtualizedListbox}
                      getOptionLabel={(option) => option}
                      loading={loading}
                      disabled={firstTimeRunFourthTab}
                      value={locationFourthTab}
                      onChange={(event, newValue) =>
                        setLocationFourthTab(newValue)
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Location"
                          placeholder={
                            loading ? "Loading locations..." : "Select location"
                          }
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loading && (
                                  <CircularProgress color="inherit" size={20} />
                                )}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </FormControl>
                </Box>
                <Button
                  variant="outlined"
                  size="large"
                  color="primary"
                  onClick={() => handleSubmitForFourthTab("direct")}
                  disabled={isSubmitDisabled || firstTimeRunFourthTab}
                >
                  Submit
                </Button>
              </Box>
              <Divider
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  alignSelf: "stretch",
                }}
              />
              <IntentClusters
                data={clusters}
                tab={3}
                setAlgorithmProp={setAlgorithm}
                setOverlapProp={setOverlap}
                OnSubmitFunc={() => handleSubmitForFourthTab("rerun")}
                reRunState={!firstTimeRunFourthTab}
              />
              <Box className="footer-icons">
                <Button
                  size="large"
                  color="primary"
                  variant="outlined"
                  className="addicon"
                  startIcon={<DownloadIcon />}
                  disabled={clusters.length === 0}
                  onClick={() =>
                    ConvertToJSONToCSV(
                      clusters,
                      `clusters-${formatDate(new Date())}`,
                      4
                    )
                  }
                >
                  CSV
                </Button>
                <Button
                  size="large"
                  color="primary"
                  variant="contained"
                  className="addicon"
                  onClick={handleNext}
                  endIcon={<ArrowForward />}
                  disabled={clusters.length === 0}
                >
                  Next
                </Button>
              </Box>
              <Stepper
                data={stepper || []}
                nextStepCsv={setForNextStepCsv}
                csvFile={forNextStepCsv}
              />
            </>
          )}
          {tabIndex === 4 && (
            <>
              <Box className="fifthTab">
                <Box className="controls">
                  <FormControl sx={{ width: 180 }}>
                    <InputLabel id="tightness-select-label">
                      Tightness
                    </InputLabel>
                    <Select
                      labelId="tightness-select-label"
                      id="tightness-select"
                      value={tightness}
                      label="tightness"
                      disabled={firstTimeRunFifthTab}
                      onChange={(e) => setTightness(e.target.value)}
                    >
                      <MenuItem value="High">High</MenuItem>
                      <MenuItem value="Medium">Medium</MenuItem>
                      <MenuItem value="Low">Low</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
                <Button
                  variant="outlined"
                  size="large"
                  color="primary"
                  disabled={!tightness || firstTimeRunFifthTab}
                  onClick={() => handleSubmitForFifthTab("direct")}
                >
                  Submit
                </Button>
              </Box>
              <Divider
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  alignSelf: "stretch",
                }}
              />
              <IntentClusters
                dataRes={intentClusters}
                tab={4}
                setTightnessProp={setTightness}
                OnSubmitFunc={() => handleSubmitForFifthTab("rerun")}
                reRunState={!firstTimeRunFifthTab}
              />
              <Box className="footer-icons">
                <Button
                  size="large"
                  color="primary"
                  variant="outlined"
                  className="addicon"
                  startIcon={<DownloadIcon />}
                  disabled={
                    Array.isArray(intentClusters) && intentClusters.length === 0
                  }
                  onClick={() =>
                    ConvertToJSONToCSV(
                      intentClusters,
                      `intentClusters-${formatDate(new Date())}`,
                      5
                    )
                  }
                >
                  CSV
                </Button>
              </Box>
              <Stepper
                data={fifthStepper || []}
                nextStepCsv={setForNextFifthStepCsv}
                csvFile={forNextFifthStepCsv}
              />
            </>
          )}
        </Box>
      </Loader>
    </Box>
  );
};

export default TopicStartegyBuilder;
